import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsTabs = _resolveComponent("SettingsTabs")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('heading'))
    }, [
      _createElementVNode("h1", {
        class: _normalizeClass(_ctx.b('title'))
      }, _toDisplayString(_ctx.$t("Настройки")), 3),
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('subtitle'))
      }, _toDisplayString(_ctx.$t("Верификация аккаунта, тест знаний рынка и платежные реквизиты")), 3)
    ], 2),
    _createVNode(_component_SettingsTabs, {
      class: _normalizeClass(_ctx.b('tabs')),
      tab: _ctx.tab,
      "onUpdate:tab": _ctx.tabChange
    }, null, 8, ["class", "tab", "onUpdate:tab"]),
    _createVNode(_Transition, {
      name: "settings-panel",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.displayedComponent), { key: _ctx.tab }))
      ]),
      _: 1
    })
  ], 2))
}